<template>
  <div class="dashboard-block" v-if="!booking.is_offer">
    <h2>{{ $t('Shortlist Used') }}</h2>

    <div class="shortlist-backing">
      <div v-if="bookingHasNoShortlistedTalent" class="m-t-md text-center">
        There are no {{ $t('shortlisted stars') }}.
      </div>
      <ul v-else class="shortlist shortlist-horizontal shortlist-col-4">
        <booking-search-details-list-item
          v-for="user in bookingShortlistedTalent"
          :key="user.id"
          :user="user"/>
      </ul>

    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingSearchDetailsListItem from './BookingSearchDetailsListItem'

export default {
  mixins: [helpers],

  components: {
    BookingSearchDetailsListItem
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
